import { authApiEndpoint } from "../utils/env";

async function fetchWithAuth(url, token, options = {}) {
  const headers = options.headers ? { ...options.headers } : {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  headers["Content-Type"] = headers["Content-Type"] || "application/json";
  const res = await fetch(url, { ...options, headers });
  const txt = await res.text();
  let json = null;
  try {
    json = txt ? JSON.parse(txt) : null;
  } catch {
    json = txt;
  }
  if (!res.ok) {
    const errMsg =
      json && json.message
        ? json.message
        : typeof json === "string"
          ? json
          : res.statusText;
    const error = new Error(errMsg || `Request failed: ${res.status}`);
    error.status = res.status;
    error.details = json;
    throw error;
  }
  return json;
}

export async function getOrganizationUsers(token) {
  const url = authApiEndpoint("/api/ApplicationUser/ListOrganizationUsers");
  return fetchWithAuth(url, token, { method: "GET" });
}

export async function getUserInfoById(token, userId) {
  const url = authApiEndpoint("/api/ApplicationUser/GetUserInfo");
  // ApplicationUserModel has several non-nullable string fields; the .NET 9 model
  // binder rejects requests missing them with 400. Send empty placeholders.
  return fetchWithAuth(url, token, {
    method: "POST",
    body: JSON.stringify({
      ID: userId,
      UserName: "",
      Email: "",
      Password: "",
      FullName: "",
      PhoneNumber: "",
      Role: "",
      Organization: "",
    }),
  });
}

export async function setOrgAdmin(token, userId, isOrgAdmin) {
  const url = authApiEndpoint("/api/ApplicationUser/SetOrgAdmin");
  return fetchWithAuth(url, token, {
    method: "POST",
    body: JSON.stringify({ userId, isOrgAdmin }),
  });
}

export async function setUserActive(token, userId, isActive) {
  const url = authApiEndpoint("/api/ApplicationUser/SetUserActive");
  return fetchWithAuth(url, token, {
    method: "POST",
    body: JSON.stringify({ userId, isActive }),
  });
}

export async function createOrganizationUser(token, payload) {
  const url = authApiEndpoint("/api/ApplicationUser/Register");
  return fetchWithAuth(url, token, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function getM365DirectoryUsers(token) {
  const url = authApiEndpoint("/api/M365Integration/DirectoryUsers");
  return fetchWithAuth(url, token, { method: "GET" });
}

export async function activateM365Users(token, users) {
  const url = authApiEndpoint("/api/M365Integration/ActivateUsers");
  return fetchWithAuth(url, token, {
    method: "POST",
    body: JSON.stringify({ users }),
  });
}

export async function getM365Configuration(token) {
  const url = authApiEndpoint("/api/M365Integration/Configuration");
  return fetchWithAuth(url, token, { method: "GET" });
}

export async function saveM365Configuration(token, config) {
  const url = authApiEndpoint("/api/M365Integration/Configuration");
  return fetchWithAuth(url, token, {
    method: "POST",
    body: JSON.stringify(config),
  });
}

// ─── Windows Auth / Active Directory Configuration ─────────────

export async function getWindowsAuthConfiguration(token) {
  const url = authApiEndpoint("/api/WindowsAuth/Configuration");
  return fetchWithAuth(url, token, { method: "GET" });
}

export async function saveWindowsAuthConfiguration(token, config) {
  const url = authApiEndpoint("/api/WindowsAuth/Configuration");
  return fetchWithAuth(url, token, {
    method: "POST",
    body: JSON.stringify(config),
  });
}

export async function getWindowsAuthStatus(token) {
  const url = authApiEndpoint("/api/WindowsAuth/Status");
  return fetchWithAuth(url, token, { method: "GET" });
}
